import { REPORT_TIME_YEAR } from '../properties/date-time.properties';
import * as moment from 'moment';

export const reportMonthYearList = (date?: string): string[] => {
  const currentDate = date ? new Date(date) : new Date();

  return [
    moment(getPrevMonth(currentDate)).format(REPORT_TIME_YEAR),
    moment(currentDate).format(REPORT_TIME_YEAR),
    moment(getNextMonth(currentDate)).format(REPORT_TIME_YEAR),
  ];
};

export const getNextMonth = (date: Date): Date => {
  if (date.getMonth() === 11) {
    return new Date(date.getFullYear() + 1, 0, 1);
  } else {
    return new Date(date.getFullYear(), date.getMonth() + 1, 1);
  }
};

export const getPrevMonth = (date: Date): Date => {
  const previousMonth = new Date(date.getTime());

  return new Date(previousMonth.setDate(0));
};
